import { Info } from "@phosphor-icons/react";
import { NormalText, TitleStyled } from "../styles";
import { ContainerSyled } from "./styles";
import { Box, useTheme } from "@mui/material";

export const Announcement = ({
  title,
  description,
  type = "normal",
  withInfoIcon = false,
}) => {
  const theme = useTheme();

  const colorStyles = {
    normal: {
      border: theme.palette.grey[1],
      background: theme.palette.background.default,
    },
    info: {
      border: "#0097f6",
      background: "#eef8ff",
    },
    error: {
      border: "#EA7A7A",
      background: "#FFF6F6",
    },
  };
  return (
    <ContainerSyled colorStyles={colorStyles[type]}>
      {withInfoIcon && <Info size={16} />}
      <Box display="flex" flexDirection="column" gap={"8px"} flex={1}>
        {title && <TitleStyled>{title}</TitleStyled>}
        {description &&
          (typeof description === "string" ? (
            <NormalText>{description}</NormalText>
          ) : (
            description
          ))}
      </Box>
    </ContainerSyled>
  );
};
